import(/* webpackMode: "eager" */ "/app/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/lib/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeRegistry"] */ "/app/lib/ThemeRegistry.tsx");
